import type { Ref } from 'vue'
import { ref } from 'vue'

import type { ReportDetail, ReportDictionaryItem, ReportTaskListItem } from '@/api/schemas/reports/common'
import type {
    OperatorReportingInterruptedReport,
    OperatorReportingOrderJobListItem,
    OperatorReportingReportItemOrder,
    OperatorReportingReportItemOrdersFilters,
    OperatorReportingSession,
    OperatorReportingShippingGroup,
    OperatorReportingWorkspace,
    OperatorReportingWorkspaceListItem
} from '@/api/schemas/reports/operatorReporting'
import { REPORTS } from '@/constants'

export function createInitialReportItemOrdersFilters(): OperatorReportingReportItemOrdersFilters {
    return {
        shippingGroupCodes: REPORTS.OPERATOR_REPORTING.DEFAULT_SHIPPING_GROUP_CODES.join(',')
    }
}

export type OperatorReportingState = {
    availableWorkspaces: Ref<OperatorReportingWorkspaceListItem[]>
    availableWorkspacesLoading: Ref<boolean>
    bootstrapLoading: Ref<boolean>
    selectedWorkspaceId: Ref<number | null>
    selectedWorkspace: Ref<OperatorReportingWorkspace | null>
    activeSession: Ref<OperatorReportingSession | null>
    unfinishedReport: Ref<OperatorReportingInterruptedReport | null>
    interruptedReports: Ref<ReportDetail[]>
    interruptedReportsLoading: Ref<boolean>
    reportOrderJobs: Ref<OperatorReportingOrderJobListItem[]>
    reportOrderJobsLoading: Ref<boolean>
    shippingGroups: Ref<OperatorReportingShippingGroup[]>
    reportItemOrders: Ref<OperatorReportingReportItemOrder[]>
    reportItemOrdersLoading: Ref<boolean>
    reportItemOrdersFilters: Ref<OperatorReportingReportItemOrdersFilters>
    scheduledTasks: Ref<ReportTaskListItem[]>
    scheduledTasksLoading: Ref<boolean>
    taskSearchResults: Ref<ReportTaskListItem[]>
    taskSearchLoading: Ref<boolean>
    reportProcesses: Ref<ReportDictionaryItem[]>
    outOfSequenceCodes: Ref<ReportDictionaryItem[]>
    selectedTask: Ref<ReportTaskListItem | null>
    taskSearch: Ref<string | null>
}

export function createOperatorReportingState(): OperatorReportingState {
    return {
        availableWorkspaces: ref<OperatorReportingWorkspaceListItem[]>([]),
        availableWorkspacesLoading: ref(false),
        bootstrapLoading: ref(false),
        selectedWorkspaceId: ref<number | null>(null),
        selectedWorkspace: ref<OperatorReportingWorkspace | null>(null),
        activeSession: ref<OperatorReportingSession | null>(null),
        unfinishedReport: ref<OperatorReportingInterruptedReport | null>(null),
        interruptedReports: ref<ReportDetail[]>([]),
        interruptedReportsLoading: ref(false),
        reportOrderJobs: ref<OperatorReportingOrderJobListItem[]>([]),
        reportOrderJobsLoading: ref(false),
        shippingGroups: ref<OperatorReportingShippingGroup[]>([]),
        reportItemOrders: ref<OperatorReportingReportItemOrder[]>([]),
        reportItemOrdersLoading: ref(false),
        reportItemOrdersFilters: ref<OperatorReportingReportItemOrdersFilters>(createInitialReportItemOrdersFilters()),
        scheduledTasks: ref<ReportTaskListItem[]>([]),
        scheduledTasksLoading: ref(false),
        taskSearchResults: ref<ReportTaskListItem[]>([]),
        taskSearchLoading: ref(false),
        reportProcesses: ref<ReportDictionaryItem[]>([]),
        outOfSequenceCodes: ref<ReportDictionaryItem[]>([]),
        selectedTask: ref<ReportTaskListItem | null>(null),
        taskSearch: ref<string | null>(null)
    }
}
